import React from "react";
import CategoryPage from "./CategoryPage";

export const SpicesPage = () => (
  <CategoryPage
    category="spices"
    headlineFr="L'épicerie."
    headlineEn="The pantry."
    sublabelFr="Cinq épices essentielles et deux infusions rares — sourcées au champ, dans l'éclat de leur récolte."
    sublabelEn="Five essential spices and two rare infusions — sourced at field level, in the brightness of their harvest."
  />
);

export const TextilesPage = () => (
  <CategoryPage
    category="textiles"
    headlineFr="Les textiles."
    headlineEn="The textiles."
    sublabelFr="Quatre savoir-faire ancestraux. Filtrez par technique — chaque pièce reste unique."
    sublabelEn="Four ancestral crafts. Filter by technique — each piece remains unique."
  />
);

export const DecoPage = () => (
  <CategoryPage
    category="deco"
    headlineFr="L'art décoratif."
    headlineEn="The decorative arts."
    sublabelFr="Quatre écoles de peinture indienne — du Mithila tribal au Tanjore royal."
    sublabelEn="Four schools of Indian painting — from tribal Mithila to royal Tanjore."
  />
);

export const OilsPage = () => (
  <CategoryPage
    category="oils"
    headlineFr="Les huiles essentielles."
    headlineEn="The essential oils."
    sublabelFr="Cinq huiles pures et un attar singulier. Distillés selon des méthodes ancestrales — du santal de Mysore au pétrichor de Kannauj."
    sublabelEn="Five pure oils and one singular attar. Distilled by ancestral methods — from Mysore sandalwood to Kannauj petrichor."
  />
);
